<template>
  <el-dialog
    title="数据对比"
    :visible="dialogVisible"
    width='928px'
    height="500px"
    :close-on-click-modal='false'
    :show-close="true"
    :before-close="closeDialog">
    <el-table
      :data="tableData"
      style="width: 100%"
      height="500px"
      :header-cell-style="{ 'background-color': '#F4F7FA', 'color': '#484A59', 'font-size': 400, }"
      :cell-style="{ 'color': '#484A59' }"
      border
      :cell-class-name="getCellClass">
      <el-table-column
        prop="name">
        <template #header>
          <el-select v-model="tabIndex" placeholder="请选择">
            <el-option v-for="(item, index) in tabs" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          {{scope.row.name}}
        </template>
      </el-table-column>
      <el-table-column
        :label="currentVersionName"
        prop="v1"
        align="center">
      </el-table-column>
      <el-table-column
        :label="otherVersionName"
        prop="v2"
        align="center">
      </el-table-column>
      <el-table-column
        label="偏差"
        prop="pc"
        align="center">
        <template v-slot="{row}">
          <span :class=" +row.pc > 0 ? 'asc' : +row.pc < 0 ? 'desc' : '' ">{{row.pc}}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    currentVersion: {
      type: String
    },
    otherVersion: {
      type: String
    },
    currentVersionName: {
      type: String
    },
    otherVersionName: {
      type: String
    }
  },
  computed: {
    cadId () {
      return this.$route.query.cadId || ''
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loadData()
      }
    },
    tabIndex () {
      this.loadData()
    }
  },
  data () {
    return {
      tableData: [],
      tabs: [{
        name: '资产统计',
        value: '2'
      }, {
        name: '区域分布',
        value: '1'
      }],
      tabIndex: '2'
    }
  },
  created () {
  },
  methods: {
    getVersionName (index) {
      return this.versionList[index] ? this.versionList[index].version + '-' + (this.versionList[index].uploadname || '未知日期') : ''
    },
    loadData () {
      this.$axios.get(this.$apis.measure.selectYhCadContrastByList, {
        type: this.tabIndex,
        cadId: this.cadId,
        v1: this.currentVersion,
        v2: this.otherVersion
      }).then(res => {
        this.tableData = res || []
      })
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    getCellClass ({ row, column }) {
      return column.property !== 'name'
        ? +row.pc > 0 ? 'green' : +row.pc < 0 ? 'red' : ''
        : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin triangle {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  margin-left: 5px;
  top: 5px;
}
.asc{
  position: relative;
  &::after{
    @include triangle;
    border-bottom: 8px solid #34E342;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    top: 0px;
  }
}
.desc{
  position: relative;
  &::after{
    @include triangle;
    border-top: 8px solid #FF3939;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
}
::v-deep{
  .green{
    background: #E5FDE7 !important;
  }
  .red{
    background: #FEF2F7 !important;
  }
}
</style>
